export default "__VITE_ASSET__S45lh5yI__"